import { buildOneTapMarketingEvent } from 'shared-utils/oneTapAnalytics';

export const buildGetAppMarketingEvent = (
  formStepName,
  formSubmissionId,
  formSubmittedResult
) => ({
  ...buildOneTapMarketingEvent(
    formStepName,
    formSubmissionId,
    formSubmittedResult
  ),
  // AnalyticsGDM otherwise derives a legacy getapp-<component>|... event.
  event: 'email_capture',
  eventName: 'email_capture',
  eventGA4Name: 'email_capture',
  site_id: 'GetApp',
});
